import { ApiResult, request, safeRequest } from '@synergy/api';
import { StaticSiteDto } from '@synergy/models';
import { noop } from '@synergy/utils';

import { LoginResult } from './models/login-result';
import { RequestPasswordResult } from './models/request-password-result';
import { ResetPasswordResult } from './models/reset-password-result';

export class LoginApi {
    constructor(protected baseUrl: string) {}

    public login(email: string, password: string): Promise<ApiResult<LoginResult>> {
        return safeRequest(
            () => request.post<LoginResult>(`${this.baseUrl}/login`, { email, password }),
            response => response.data
        );
    }

    public requestResetPassword(email: string): Promise<ApiResult<RequestPasswordResult>> {
        return safeRequest(
            () =>
                request.post<RequestPasswordResult>(`${this.baseUrl}/request-password-reset`, {
                    email,
                }),
            response => response.data
        );
    }

    public resetPassword(token: string, newPassword: string): Promise<ApiResult<ResetPasswordResult>> {
        return safeRequest(
            () => request.post<ResetPasswordResult>(`${this.baseUrl}/reset-password`, { token, newPassword }),
            response => response.data
        );
    }

    public setPassword(confirmationKey: string, password: string): Promise<ApiResult<void>> {
        return safeRequest(() => request.post(`${this.baseUrl}/set-password`, { confirmationKey, password }), noop);
    }

    public getAgb(): Promise<ApiResult<StaticSiteDto>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/static-sites/agb`),
            response => response.data
        );
    }
}
